<script setup lang="ts">
import {useRouter} from "vue-router";
import {Button} from "@/Components/Library";

const {
    title,
    route,
    showBackButton = true,
} = defineProps<{
    title: string;
    route?: object;
    showBackButton?: boolean;
}>();

const router = useRouter();
</script>
<template>
    <div class="flex w-full items-center">
        <div class="flex items-center">
            <Button
                v-if="showBackButton"
                @click="route ? router.push({...route, query: router.currentRoute.value.query}) : router.back()"
                :icon="{icon: 'mingcute:arrow-left-fill', width: 24}"
                rounded
                class="!py-1.5 !pr-2.5 !ring-0"
            />
            <slot name="title">
                <h2
                    class="text-lg font-bold !leading-9 tracking-tight lg:text-xl"
                    :class="[{'border-l border-stone-400 pl-3 !leading-none': showBackButton}]"
                >
                    {{ title }}
                </h2>
            </slot>
        </div>
        <slot></slot>
    </div>
</template>
<style scoped></style>
